import { createRouter, createWebHistory } from 'vue-router'
import Galery from '../views/Galery.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: About,
    meta: {
      heroImage: '/background/A9bac.jpg',
      heroTitleKey: 'name',
      heroSubtitleKey: 'pages.about.heroSubtitle'
    }
  },
  {
    path: '/galery',
    name: 'galery',
    component: Galery,
    meta: {
      heroImage: '/A9/A9 (4).jpg',
      heroTitleKey: 'pages.gallery.title',
      heroSubtitleKey: 'pages.gallery.subtitle'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      heroImage: '/A8/A8 (7).jpg',
      heroTitleKey: 'pages.contact.title',
      heroSubtitleKey: 'pages.contact.subtitle'
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
